export const Experiment = {
  OttaCues: "20220720_OTTACUES",
  AllSalaryBenchmarks: "20240708_SEARCH_APP_ALL_SALARY_BENCHMARKS",
  NewNotificationSettings: "20230621_NOTIFICATION_SETTINGS",
  CVUpload: "20230726_CV_UPLOAD",
  CompanyPodcast: "20240805_COMPANY_PODCAST",
  CurrentAddress: "20250331_CURRENT_ADDRESS",
  CVSignup: "20250728_CV_SIGNUP",
} as const;
